"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormInstantField = void 0;
const instant_field_1 = require("../../../components/instant-field/instant-field");
const form_field_1 = require("./form-field");
exports.FormInstantField = (0, form_field_1.formFieldFactory)(instant_field_1.InstantField);
//# sourceMappingURL=form-instant-field.js.map